import React, { memo } from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { Play } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Image, Stack } from '@lyearn/ui';
import { getAdaptedBaseCardContent } from '@/modules/content/card/utils/getAdaptedBaseCardContent';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import DefaultCard from '@/modules/content/components/ContentCard/DefaultCard';

import { NewDefaultCardProps } from '../types';

export const imageStyles = (height: number) => css`
  height: ${height}rem;
`;

const gradientOverlay = css`
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.4) 40%,
    rgba(0, 0, 0, 0) 100%
  );
`;

//re move from here
const DefaultCardMicroLearning: React.FC<NewDefaultCardProps & { showPlayButton: boolean }> = (
  props,
) => {
  const { className, baseContent, content: contentProp, showPlayButton } = props;
  const { t } = useTranslation();

  const content = baseContent ?? getAdaptedBaseCardContent(t, contentProp);

  return (
    <DefaultCard
      className={cn(className, 'flex-1 relative w-full h-full')}
      content={content}
      disabled={true}>
      <Image className="w-full h-full object-cover" src={content?.image as string} />
      <Stack className="absolute h-full w-full ">
        <BaseCard.Bookmark />
        <div className="absolute bottom-0 left-0 w-full">
          <div className={gradientOverlay}>
            <Stack alignItems="start" className="p-20 pt-16 xs:px-16" direction="col">
              <BaseCard.Label className="!text-text-white" />
              <BaseCard.Name className="mt-6 xs:mt-4 !text-text-white" numberOfLines={2} />
            </Stack>
          </div>
        </div>

        {/* Center PlayCircle */}
        <div className="absolute inset-0 flex items-center justify-center">
          {showPlayButton ? <Play className="h-64 w-64" fillColorToken="icon-white" /> : null}
        </div>
      </Stack>
    </DefaultCard>
  );
};

export default memo(DefaultCardMicroLearning);
